module.exports = __webpack_public_path__ + "media/images/ir/other/calendar/year-calendar_sp-04b83b126e4ab310cfe054049dba996f.svg";